// src/components/GlobalModal.tsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Alert,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

const iconMap = {
  success: <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />,
  error: <ErrorIcon color="error" sx={{ fontSize: 60 }} />,
  info: <InfoIcon color="info" sx={{ fontSize: 60 }} />,
};

type ModalType = "success" | "error" | "info";

export default function GlobalModal({
  open,
  type = "info",
  title,
  subtitle,
  specialInfo = undefined,
  onClose,
  actions,
  navigateTo = "/", // where to go on default Close
}: {
  open: boolean;
  type?: ModalType;
  title: string;
  subtitle?: string;
  specialInfo?: string;
  onClose: () => void;
  actions?: React.ReactNode;
  navigateTo?: string;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      dir="rtl"
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, textAlign: "center", py: 2 } }}
    >
      <IconButton
        aria-label="סגור"
        onClick={onClose}
        sx={{ position: "absolute", left: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle sx={{ mt: 1 }}>{iconMap[type]}</DialogTitle>

      <DialogContent>
        <Typography variant="h5" fontWeight={800} gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="h6" sx={{ mb: 0 }}>
            {subtitle}
          </Typography>
        )}
      </DialogContent>

      {specialInfo && (
        <Alert severity="warning" sx={{ mx: 3 }}>
          <Typography sx={{ my: 2, textAlign: "center" }}>
            <span style={{ fontSize: "13pt", fontWeight: "bold" }}>
              {specialInfo}
            </span>
          </Typography>
        </Alert>
      )}

      <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
        {actions || (
          <Button
            onClick={() => {
              onClose();
              // Hard refresh to the target path (default "/")
              window.location.replace(navigateTo);
            }}
            color="primary"
            variant="contained"
          >
            סגור
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
